export const handle_stripe_payment = (account_id) => {
    window.open(
        `https://buy.stripe.com/6oE01F9TP6U83wQ9AA?client_reference_id=${account_id}`,
        "_self"
    );
};
 
